import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import { toast } from "react-toastify";
import Avtar from '../../Assets/Images/Avatar.svg'
import { ADD_DOCTOR, BASE_URL } from "../../API";
import axios from "axios";
import Loader from "../../components/Loader";
import { ProfileContext } from "../../context/ProfileContext";

function AddDoctor() {
  const { headers, getAllDoctors } = useContext(ProfileContext)
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [preview, setPreview] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);

  const togglePasswordVisibility = () => { setShowPassword(!showPassword); };

  const loadFile = async (event) => {
    const file = event.target.files[0];

    if (!event.target.files || event.target.files.length === 0) {toast.error("Please select a file."); return}
    if (file) {
      const fileType = file.type;
      const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!validImageTypes.includes(fileType)) { toast.error("Please upload a valid image file (jpg, jpeg, png)."); return}
      setCurrentImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const onSubmit = async (data) => {
    if (!currentImage) { toast.error("Please upload a profile image."); return; }

    setIsLoading(true);
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("specialization", data.specialization);
    formData.append("password", data.password);
    formData.append("gmc_number", data.gmc_number);
    formData.append("prescriber_number", data.prescriber_number);
    if (currentImage) { formData.append("file", currentImage) }

    try {
      const response = await axios.post(BASE_URL + ADD_DOCTOR, formData, { headers });
      if (response.data.code === 200 && response.data.status === true) {
        toast.success(response.data.message);
        reset();
        setPreview(null);
        setCurrentImage(null);
        getAllDoctors();
        navigate('/doctor-management')
      }
    }
    catch (error) {
      if (error.response && error.response.data) {
        const errorMessage = error.response.data.error || "An error occurred";
        toast.error(errorMessage);
      }
    }
    finally { setIsLoading(false) }
  }

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="cstm_bredcrumb_outer">
                <Breadcrumb className="cstm_bredcrumb" listProps={{ className: "breadcrumb-custom-separator" }}>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/referral-management" }}>Patient Record Management</Breadcrumb.Item>
                  <Breadcrumb.Item active >View Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="notifi-list d-flex">
                <h6 className="comm_page_heading">Add Doctor</h6>
              </div>

              <div className="patient_referral_form">
                <div className="comm_border_box">
                  <Form className="comm_form" onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md={12}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Profile Image</Form.Label>
                          <div className="my-profile-left d-flex employer_logo_edit">
                            <div className="profile-pic">
                              <label className="label" htmlFor="file">
                                <span className="glyphicon glyphicon-camera"><BiEditAlt /></span>
                              </label>
                              <Form.Control id="file" type="file" name="profile_picture" {...register("image")}
                                onChange={(e) => { loadFile(e); setValue('image', e.target.files[0]) }}
                              />
                              <figure className="profile-img-edit">
                                <img src={preview || Avtar} alt="Profile Preview" />
                              </figure>
                            </div>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Name"
                            {...register("name", {
                              required: 'Please enter name.',
                              validate: value => value.trim() !== "" || "Name cannot be Empty or just spaces.",
                            })}
                          />
                          {errors.name && <span className="error">{errors.name.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Email</Form.Label>
                          <Form.Control type="email" placeholder="Enter Your Email" {...register('email', {
                            required: "Please enter email address",
                            pattern: {
                              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                              message: "Invalid email address"
                            }
                          })} />
                          {errors.email && <span className='error'>{errors.email.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Specialization</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Specialization"
                            {...register("specialization", {
                              required: 'Please enter Specializaton.',
                              validate: value => value.trim() !== "" || "Specialization cannot be Empty or just spaces.",
                            })}
                          />
                          {errors.specialization && <span className="error">{errors.specialization.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Password</Form.Label>
                          <div className="cstPassGroup">
                            <Form.Control
                              type={showPassword ? "text" : "password"}
                              placeholder="Enter Old Password"
                              {...register("password", {
                                required: 'Please enter Password.',
                                maxLength: { value: 25, message: 'Password must be less than 25 characters' },
                                pattern: {
                                  value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/,
                                  message: 'Password must be at least 8 characters long with uppercase, lowercase, number, special character, and no spaces',
                                }
                              })}
                            />
                            {errors.password && <span className="error">{errors.password.message}</span>}
                            <div onClick={togglePasswordVisibility} className="eyeToggleBtn">
                              {showPassword ? (<RiEyeLine />) : (<RiEyeOffLine />)}
                            </div>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Registration Number (GMC Number)</Form.Label>
                          <Form.Control type="text" placeholder="Enter GMC Number"
                            maxLength={7}
                            {...register("gmc_number", {
                              required: "Please enter your GMC Registration Number.",
                              pattern: { value: /^[0-9]{7}$/, message: "GMC Number must be exactly 7 digits." },
                            })}
                          />
                          {errors.gmc_number && (<span className="error">{errors.gmc_number.message}</span>)}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Prescriber Number</Form.Label>
                          <Form.Control type="text" placeholder="Enter Prescriber Number"
                            {...register("prescriber_number", {
                              required: "Please enter your Prescriber Number.",
                              pattern: {
                                value: /^[A-Za-z0-9\-\/]+$/,
                                message: "Prescriber Number can only contain letters, numbers, hyphens or slashes."
                              },
                              validate: (value) => value.trim() !== "" || "Prescriber Number cannot be empty or just spaces.",
                            })}
                          />
                          {errors.prescriber_number && (<span className="error">{errors.prescriber_number.message}</span>)}
                        </Form.Group>
                      </Col>

                    </Row>
                    <div className="modal_pair_btns patient_referral_btns ">
                      <button className='main-btn' type="submit">Submit</button>
                      <button className='main-outline-btn' onClick={() => { navigate('/doctor-management') }}>Discard Changes</button>
                    </div>
                  </Form>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddDoctor;